import React, { useEffect, useState } from "react";
import "./Nav.css";
function Nav() {
  const [scroll, handleScroll] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 130) {
        handleScroll(true);
      } else handleScroll(false);
    });
    return () => {
      window.removeEventListener("scroll", null);
    };
  }, []);
  const [isintro, handleisintro] = useState(true);

  const intro = () => {
    if (isintro) {
      handleisintro(false);
    } else {
      handleisintro(true);
    }
  };
  return (
    <div>
      <div className={`nav ${scroll && "nav-postscroll"}`}>
        <img
          className="logo-nav"
          src="https://i.imgur.com/RDecFmZ.png"
          alt="Rushflix Logo"
        />
        <img
          className="nav-avatar"
          onClick={() => intro()}
          src="https://i.imgur.com/bQi5SzT.png"
          alt="Nav-Avatar"
        />
        {!isintro && (
          <div className="intro">
            <img
              className="dp"
              src="https://i.imgur.com/wfDOHaK.png"
              // width="150px"
              alt="Owners pic"
            />
            <div> &nbsp;</div>
            <h1 className="h11">Rushflix: A React App </h1>
            &nbsp;
            <h4 className="h44">-Designed and Developed by Rushabh Karade</h4>
            <h4 className="h44">Email Id: karaderushabh2000@gmail.com</h4>
          </div>
        )}
      </div>
    </div>
  );
}

export default Nav;
